import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import { ChipOnBAB } from './ChipOnBAB'
import { ContainerBAB, StyledAnte } from './styles'

export const Ante: FC<{
  selected: boolean
  box: BoxStore
}> = observer(({ selected, box }) => {
  return (
    <ContainerBAB
      selected={selected}
      data-cy={`rp-ante-btn-${box.seatNumber}`}
      onClick={() => {
        box.sendPlaceAnte()
      }}>
      <StyledAnte selected={selected} />
      {box.ante > 0 && <ChipOnBAB amount={box.ante} />}
    </ContainerBAB>
  )
})
